"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoleClass = exports.POLE_LENGTH_INCREMENT = exports.MAX_POLE_LENGTH = exports.MIN_POLE_LENGTH = void 0;
exports.poleLengths = poleLengths;
exports.normalClasses = normalClasses;
exports.hClasses = hClasses;
exports.isPoleClass = isPoleClass;
exports.poleLengthsForClass = poleLengthsForClass;
exports.MIN_POLE_LENGTH = 20;
exports.MAX_POLE_LENGTH = 125;
exports.POLE_LENGTH_INCREMENT = 5;
function poleLengths() {
    const result = [];
    for (let i = exports.MIN_POLE_LENGTH; i <= exports.MAX_POLE_LENGTH; i += exports.POLE_LENGTH_INCREMENT) {
        result.push(i);
    }
    return result;
}
/**
 * ANSI O5.1 Wood Pole Classes
 */
var PoleClass;
(function (PoleClass) {
    PoleClass["H6"] = "H6";
    PoleClass["H5"] = "H5";
    PoleClass["H4"] = "H4";
    PoleClass["H3"] = "H3";
    PoleClass["H2"] = "H2";
    PoleClass["H1"] = "H1";
    PoleClass["Class1"] = "1";
    PoleClass["Class2"] = "2";
    PoleClass["Class3"] = "3";
    PoleClass["Class4"] = "4";
    PoleClass["Class5"] = "5";
    PoleClass["Class6"] = "6";
    PoleClass["Class7"] = "7";
    PoleClass["Class9"] = "9";
    PoleClass["Class10"] = "10";
})(PoleClass || (exports.PoleClass = PoleClass = {}));
function normalClasses() {
    return [
        PoleClass.Class1,
        PoleClass.Class2,
        PoleClass.Class3,
        PoleClass.Class4,
        PoleClass.Class5,
        PoleClass.Class6,
        PoleClass.Class7,
        PoleClass.Class9,
        PoleClass.Class10,
    ];
}
function hClasses() {
    return [PoleClass.H1, PoleClass.H2, PoleClass.H3, PoleClass.H4, PoleClass.H5, PoleClass.H6];
}
function isPoleClass(val) {
    return Object.values(PoleClass).includes(val);
}
/**
 * Returns the list of pole lengths (in feet) which are defined for the given Pole Class.
 * For example, this function returns [20, 25] for PoleClass.Class10.
 */
function poleLengthsForClass(poleClass) {
    switch (poleClass) {
        case PoleClass.H6:
            return poleLengths();
        case PoleClass.H5:
            return poleLengths();
        case PoleClass.H4:
            return poleLengths();
        case PoleClass.H3:
            return poleLengths();
        case PoleClass.H2:
            return poleLengths();
        case PoleClass.H1:
            return poleLengths();
        case PoleClass.Class1:
            return poleLengths();
        case PoleClass.Class2:
            return poleLengths();
        case PoleClass.Class3:
            return poleLengths().filter((length) => length <= 90);
        case PoleClass.Class4:
            return poleLengths().filter((length) => length <= 70);
        case PoleClass.Class5:
            return poleLengths().filter((length) => length <= 50);
        case PoleClass.Class6:
            return poleLengths().filter((length) => length <= 45);
        case PoleClass.Class7:
            return poleLengths().filter((length) => length <= 35);
        case PoleClass.Class9:
            return poleLengths().filter((length) => length <= 30);
        case PoleClass.Class10:
            return poleLengths().filter((length) => length <= 25);
        default:
            throw new Error(`Unrecognized PoleClass: ${poleClass}`);
    }
}
//# sourceMappingURL=PoleDimensions.js.map